import React from 'react';
import {Provider} from 'react-redux';
import ThemeProvider from '@deezer/next/shared/providers/ThemeProvider';
import D4CTools from '@deezer/next/components/D4CTools';
import {D4CToolsProvider} from '@deezer/next/components/D4CTools/D4CToolsContext';
import DidomiConsent from '@components/DidomiConsent';
import configureStore from '@deezer/next/shared/store/index';
import MainContextProvider from '@deezer/next/contexts/main';
import LocalizationProvider from '@deezer/next/contexts/localization';
import type {ThemePreference} from '@deezer/next/services/storage/shared/types';
import SharedThemeSync from '@deezer/next/shared/theme/components/SharedThemeSync';

type AppProvidersProps = {
	children: React.ReactNode;
	mode?: ThemePreference;
};

const store = configureStore();

const AppProviders = ({children, mode}: AppProvidersProps) => {
	return (
		<LocalizationProvider>
			<D4CToolsProvider>
				<ThemeProvider mode={mode}>
					<DidomiConsent />
					<D4CTools />
					<Provider store={store}>
						<MainContextProvider>
							<SharedThemeSync />
							{children}
						</MainContextProvider>
					</Provider>
				</ThemeProvider>
			</D4CToolsProvider>
		</LocalizationProvider>
	);
};

export default AppProviders;
